import { useState, useRef, useEffect } from "react";
import Score from "./form/Score.jsx";
import { useNavigate } from "react-router-dom";
import MatchDetailsTeamA from "./MatchDetailsTeamA.jsx";
import MatchDetailsTeamB from "./MatchDetailsTeamB.jsx";
import { SaveGuessGroup } from "../repo/GroupsRepo.js";

var timex
export default function MatchDetailsForm({groupId, match, bet, handleGuessingStatus, handleResponseError}) {
  const navigate = useNavigate()
  const guessValueIntervalError = "Só palpites de 0 a 999 são aceitos."
  const TIMER = 1000
  const guessScoreTeamA = useRef();
  const guessScoreTeamB = useRef();
  const [currentGuessScoreTeamA, setCurrentGuessScoreTeamA] =
    useState(bet.id === null ? "" : bet.guess_score_team_a.toString())
  const [currentGuessScoreTeamB, setCurrentGuessScoreTeamB] =
    useState(bet.id === null ? "" : bet.guess_score_team_b.toString())

  const handleResponse = (respStatus) => {
    if (respStatus === 400) {
      handleGuessingStatus("Error")
      handleResponseError("Só é possível dar palpites em jogos que ainda não começaram.")
    } else if (respStatus === 422) {
      handleGuessingStatus("Error")
      handleResponseError(guessValueIntervalError)
    } else if (respStatus === 403) {
      handleGuessingStatus("Warning")
      handleResponseError("Sua sessão expirou, faça login novamente.")
      setTimeout(() => {
        navigate('/')
      }, 5000)
    } else if (respStatus > 400 && respStatus <= 499) {
      navigate('/')
    } else {
      handleGuessingStatus("Saved")
      handleResponseError("")
      setCurrentGuessScoreTeamA(guessScoreTeamA.current.value)
      setCurrentGuessScoreTeamB(guessScoreTeamB.current.value)
    }
  }

  const validateGuess = () => {
    const regexInt = new RegExp("^\\d+$")

    return (
      regexInt.test(guessScoreTeamA.current.value) &&
      regexInt.test(guessScoreTeamB.current.value)
    )
  }

  const scoreChanged = () => {
    return (
      (currentGuessScoreTeamA !== guessScoreTeamA.current.value) ||
      (currentGuessScoreTeamB !== guessScoreTeamB.current.value)
    )
  }

  const neverBeenSaved = () => {
    return (
      (currentGuessScoreTeamA === "") || (currentGuessScoreTeamB === "")
    )
  }

  const handleScoreGuessing = () => {
    unsetTimerForSavingGuess()

    if (validateGuess()) {
      if (scoreChanged()) {
        handleGuessingStatus("Saving")
        SaveGuess(groupId, {
          guess_score_team_a: guessScoreTeamA.current.value,
          guess_score_team_b: guessScoreTeamB.current.value,
          match_id: match.id,
        }).then(
          respStatus => handleResponse(respStatus)
        )
      } else {
        handleGuessingStatus("Saved")
        handleResponseError("")
      }
    } else {
      if (neverBeenSaved()) {
        handleGuessingStatus("")
        handleResponseError("")
      } else {
        handleGuessingStatus("Error")
        handleResponseError(guessValueIntervalError)
      }
    }
  }

  const handleChangeScoreTeamA = (event) => {
    unsetTimerForSavingGuess()
    setTimerForSavingGuess()
  }

  const handleChangeScoreTeamB = (event) => {
    unsetTimerForSavingGuess()
    setTimerForSavingGuess()
  }

  const setTimerForSavingGuess = () => {
    timex = setTimeout(() => {
      handleScoreGuessing()
    }, TIMER)

    return () => {
      unsetTimerForSavingGuess()
    }
  }

  const unsetTimerForSavingGuess = () => {
    try {
      clearTimeout(timex)
    } catch {

    }
  }

  useEffect(() => {
    guessScoreTeamA.current.value = currentGuessScoreTeamA;
    guessScoreTeamB.current.value = currentGuessScoreTeamB;

    if (bet.id !== null) {
      handleGuessingStatus("Saved")
    }

  }, [currentGuessScoreTeamA, currentGuessScoreTeamB]);

  return (
    <div className="flex flex-col pb-4">
      <form className="flex flex-row justify-center" key={"form-" + groupId + "|" + match.id} id={groupId + "|" + match.id}>
        <MatchDetailsTeamA match={match} />
        <div className="items-center flex">
          <Score
            type="number"
            onBlur={handleScoreGuessing}
            onChange={handleChangeScoreTeamA}
            ref={guessScoreTeamA}
            min="0"
            max="999"
            step="1"
          />
        </div>
        <div className="flex px-2 items-center justify-center">x</div>
        <div className="items-center flex">
          <Score
            type="number"
            onBlur={handleScoreGuessing}
            onChange={handleChangeScoreTeamB}
            ref={guessScoreTeamB}
            min="0"
            max="999"
            step="1"
          />
        </div>
        <MatchDetailsTeamB match={match} />
      </form>
    </div>
  )
}

async function SaveGuess(groupId, guess) {
  const response = await SaveGuessGroup(groupId, guess)

  return response.status
}
